import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class IpService {
  constructor() {
    const serverType = this.getServerType();
    const ipAddress = this.getLocalIPAddress();
    this.setServerType(serverType);
    this.setLocalIPAddress(ipAddress);
  }

  getServerType(serverType?: string) {
    const storedServerType = localStorage.getItem('SERVER_TYPE');

    if (serverType) {
      return serverType;
    } else if (storedServerType) {
      return storedServerType;
    }

    return 'API_SERVER';
  }

  getLocalIPAddress() {
    const storedIPAddress = localStorage.getItem('LOCAL_IP_ADDRESS');

    if (storedIPAddress) {
      return storedIPAddress;
    }

    return '127.0.0.1';
  }

  setServerType(serverType: string) {
    localStorage.setItem('SERVER_TYPE', serverType);
  }

  setLocalIPAddress(ipAddress: string) {
    localStorage.setItem('LOCAL_IP_ADDRESS', ipAddress);
  }
}
